import React, { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import axios from "axios";
// import Data from "./components/Utils/content.json" Uncomment to access local data
import Header from "./components/Header/index.js";
import { useParams} from 'react-router-dom';
import Banner from "./components/Banner/Banner";
import rootReducer from "./store/reducers";
import { legacy_createStore as createStore } from 'redux'
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import useSunWestSuccessYears from './components/Utils/useSunWestSuccessYears.js';
import useRefinancePageData from "./components/Utils/useRefinancePageData.js";
import Shimmer from "./components/ShimmerUI/ShimmerUI.js";
import MediaQuery from "react-responsive";
import aibrokerlocaldata from "./aibroker.json";
import useCommonJson from "./components/Utils/useCommonJson.js";

import { CookieSetting } from "cookiesetting-component";

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const RefinanceCarousel = lazy(() => import("./components/RefinanceCarousel/RefinanceCarousel.js"));
const WhyRefinance = lazy(() => import("./components/WhyRefinance/WhyRefinance.js"));
const RealEstateAgent = lazy(() => import("./components/RealEstateAgent/index.js"));
const Tru = lazy(() => import("./components/Tru/tru.js"));
const Products = lazy(() => import("./components/Products/products.js"));
const WhyChooseSunwest = lazy(() => import("./components/WhyChooseSunwest/WhyChooseSunwest.js"));
const TopRealtors = lazy(() => import("./components/TopRealtors/TopRealtors.js"));
const MindsetSummitCarousel = lazy(() => import("./components/EventHighlightsCarousel/HighlightsCarousel.js"));
const LogoCarousel = lazy(() => import("./components/Logo Section/NewLogoSection.js"));
const Celebrity = lazy(() => import("./components/CelebritySection/Celebrity.js"));
const RealStories = lazy(() => import("./components/RealStories/RealStories.js"));
const Blog = lazy(() => import("./components/Blog/Blog.js"));
const Disclaimer = lazy(() => import("./components/Disclaimer/Disclaimer.js"));
const LoTemplate = lazy(() => import("./components/LoTemplate/LoTemplate.js"));
const ContactUs = lazy(() => import("./components/ContactUs/ContactUs"));
const Footer = lazy(() => import("./components/Footer/Footer.js"));


export default function Home() {
  const [Loading, setLoading] = useState(true);
  const [ProductsData, setProductsData] = useState();
  const data = useRefinancePageData();
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const [TruData, setTruData] = useState();
  const successYears = useSunWestSuccessYears();
  const { loName } = useParams();
  const loCommonData = useCommonJson(loName);

  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);  // Scroll to top on page refresh
  }, []);

  useEffect(() => {
    const fetchAiiaJSON = async () => {
      try {
        const url = process.env.REACT_APP_CDN_URL + "aibroker/aibroker.json"; // Use the CDN URL from environment variables
        const response = await axios.get(url);
        const aibrokerJsonData = response.datanew;
        setTruData(aibrokerJsonData.truapproval);
        setProductsData(aibrokerJsonData.products);
        setLoading(false);
      } catch (error) {
        console.log("Failed to fetch JSON from CDN:", error);
        setTruData(aibrokerlocaldata.truapproval);
        setProductsData(aibrokerlocaldata.products);
        setLoading(false);
      }
    };

    fetchAiiaJSON();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  if (data === null ) {
    return <Shimmer />
  } else if (loName !== null && data === null){
    return <Shimmer />
  }

  const loadingStyle = {
    textAlign: 'center'
  };

  

  return (
    <>
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      <Header fetchpriority="high" />
      <Provider store={store}>
        <Suspense fallback={<div />}>
          <Banner fetchpriority="high" data={data} loCommonData={loCommonData} />
        </Suspense>
        
          <Suspense fallback={<div />}>
            <LogoCarousel />
          </Suspense>
          
          <Suspense fallback={<div></div>}>
                <Tru data={data} />
              </Suspense>
              
      </Provider>
       
      
      {showOtherComponents && (
        <>
         <Suspense fallback={<div></div>}>
                <Products data={data} />
              </Suspense>
          <Suspense fallback={<div style={loadingStyle}></div>}>
            <RealStories data={data} />
          </Suspense>
          <Suspense fallback={<div />}>
          <RealEstateAgent data={data} />
        </Suspense>
          <Suspense fallback={<div />}>
          <RefinanceCarousel data={data} />
        </Suspense>
          <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>
            {/* <WhyRefinance data={data} /> */}
            <WhyChooseSunwest data={data} />
          </Suspense>
          <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>
            <TopRealtors data={data} />
          </Suspense>
          <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>
            <MindsetSummitCarousel data={data} />
          </Suspense>
          <div className="celebrity-videos-section">
            <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>
              <Celebrity data={data} />
            </Suspense>
          </div>
          <Suspense fallback={<div>Loading...</div>}>
                <ContactUs />
              </Suspense>
          <Suspense fallback={<div />}>
            <Disclaimer fetchpriority="low" data={data} />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer fetchpriority="low" />
          </Suspense>
        </>
      )}


    </>
  );
}

